export const SAMPLE_FIELD_LABELS = {
  samplingDate: "Sampling Date",
  samplingMethod: "Sampling Method",
  sampleWeight: "Sample Weight",
  locationFallback: "Facility",
} as const;

export const SAMPLE_SECTION_LABELS = {
  samplingFacility: "Sampling Facility",
  addSamplingFacility: "Add Sampling Facility",
} as const;

/** Facility label: use API location_type when present, else "Facility". Never "Location". */
export function getLocationFieldLabel(locationType?: string | null): string {
  return locationType || SAMPLE_FIELD_LABELS.locationFallback;
}
